<template>
    <div>
        <v-data-table :headers="headers" :items="items" hide-default-header hide-default-footer>
            <template v-slot:header>
                <tr><td colspan=7><label-component horizontal="left">■この契約の関係者</label-component></td></tr>
            </template>
            <template v-slot:item.sn="{ item }">
                <v-avatar v-if="item.signature_status !== 0" :size="30" color="grey lighten-4">
                    <v-icon v-if="item.signature_status === 1" color="green">mdi-check</v-icon>
                    <v-icon v-else-if="item.signature_status === 2">mdi-close-circle-outline</v-icon>
                    <v-icon v-else-if="item.signature_status === 3" color="blue">mdi-send</v-icon>
                </v-avatar>
                <v-avatar v-else :size="30" color="grey lighten-1"></v-avatar>
            </template>
            <template v-slot:item.has_access_code="{ item }">
                <v-icon v-if="item.has_access_code">mdi-lock</v-icon>
                <div v-if="isRemindStatus && (destFirstUnsignedId == item.id) && isExistsReminderEnable">
                    <div class="text-right">URL有効期限：{{ formatRemindDate(reminderEmail.expiration_date) }}</div>
                    <div class="text-right">リマインド日：{{ formatRemindDate(reminderEmail.send_datetime) }}</div>
                </div>
            </template>
            <template v-slot:item.remarks="{ index, item }">
                <div class="text-right" :style="getYourNameColor(item)">{{ getSignatureStatus(item) }}<span v-if="user.email === item.destination_email_address">(あなた)</span></div>
                <div class="text-right">
                    <span v-if="item.opening_status != 3">{{ getOpenStatusOrSignatureDate(item) }}</span>
                    <span v-else style="color: red">{{ getOpenStatusOrSignatureDate(item) }}</span>
                </div>
                <div class="text-right">
                    <v-btn v-if="isRemindStatus && (destFirstUnsignedId== item.id) && (user.email != item.destination_email_address) && isExistsReminderEnable" class="black--text" disabled>リマインド済み</v-btn>
                    <v-btn v-else-if="isRemindStatus && (destFirstUnsignedId== item.id) && (user.email != item.destination_email_address)" class="white--text" color="orange" @click="remind(item)" :disabled="disabled">リマインドする</v-btn>
                    <v-btn v-else-if="isConfReq && (destFirstUnsignedId == item.id) && (user.email === item.destination_email_address)" class="white--text" color="red" :href="signatureUrl">確認して{{ item.is_authorizer ? "承認" : "署名" }}する</v-btn>
                </div>  
            </template>
        </v-data-table>
        <!-- メッセージ -->
        <message-component id="message" v-model="isMessage" :success="message.success">{{ message.text }}</message-component>
    </div>
</template>

<script>
    import moment from 'moment';
    const DAY_OF_WEEK = [ "日", "月", "火", "水", "木", "金", "土" ];
    
    export default {
        data() {
            return {
                destFirstUnsignedId: null,          //  未署名・未承認の一番最初の送付先のID
                disabled : false,
                headers: [
                    { text: 'sn', value: 'sn' },
                    { text: '氏名', value: 'destination_user_name' },
                    { text: 'メールアドレス', value: 'destination_email_address' },
                    { text: '会社名', value: 'destination_company_name' },
                    { text: 'アクセスコード有無', value: 'has_access_code' },
                    { text: '備考', value: 'remarks' },
                ],
                message: {
                    success: false,
                    text: "",
                }
            };
        },
        props: {
            user: Object,
            destFirstUnsigned: Object,
            reminderEmail: Object,              //リマインダ
            isExistsReminderEnable: Boolean,    // 現在のリマインダが有効
            signatureUrl: String,               // 署名・承認URL
            items: Array,                       // 契約送付先リスト
            isDraft: Boolean,                   // 下書き
            isRemindStatus: Boolean,            // リマインド可能なステータス
            isApplying: Boolean,                // 申請中
            isConfReq: Boolean,                 // 要確認（確認して署名・承認する）
            rejectionDate: String               // 却下日
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        created() {
            if (this.destFirstUnsigned) {
                this.destFirstUnsignedId = this.destFirstUnsigned.id;
            }
        },
        methods: {
            // あなたの氏名の色
            getYourNameColor(item) {
                let color = "";
                if (item.signature_status == 2) {    // 却下
                    color = "color: red";
                } else if (item.signature_status == 3) { // 転送
                    color = "color: blue";
                } else if (this.destFirstUnsignedId == item.id) {
                    color = "color: green";
                }
                return color;
            },
            // 署名状態
            getSignatureStatus(item) {
                if (this.isDraft) {
                    // 下書きの時
                    return this.user.email === item.destination_email_address ?  "送信者" : "";
                }
                if (item.is_destination === 0 && item.signature_status != 2) {
                    // 送信元の時
                    return "送信済み";
                }
                
                let res = this.isApplying ? "申請中" : "確認待ち";
                res = this.isConfReq && (this.user.email === item.destination_email_address) ? "要確認" : res;
                
                if (item.signature_status == 1){
                    res = "確認済み";
                } else if (item.signature_status == 2){
                    res = "却下";
                } else if (item.signature_status == 3){
                    res = "転送";
                }
                return res;
            },
            // 開封状態 or 署名日付
            getOpenStatusOrSignatureDate(item) {
                if (this.isDraft || (item.signature_status == 3)) {
                    // 下書き、転送の時
                    return "";
                }
                // 署名：未承認の場合 開封状況を表示
                if (item.signature_status == 0) {
                    let res = "未送信";
                    if (item.opening_status == 1) {
                        res = "未開封";
                    } else if (item.opening_status == 2) {
                        res = "開封済";
                    } else if (item.opening_status == 3) {
                        res = "送信エラー";
                    }
                    return res;
                }
                // 署名：未承認以外の場合 署名日時を表示
                let date = item.signature_status == 2 ? this.rejectionDate : item.signature_datetime;   // 却下の場合は却下日、却下以外は署名日時
                let res = "";
                if (moment(new Date()).format('YYYY/MM/DD') == moment(new Date(date)).format('YYYY/MM/DD')) {
                    // 今日の場合は時間表示のみ
                    res =  moment(date).format('kk:mm');
                } else {
                    let w = new Date(date).getDay(); // 曜日
                    res = moment(date).format('YYYY/MM/DD') + "(" + DAY_OF_WEEK[w] + ")"; 
                }
                return res;
            },
            // リマインドの日付をフォーマット
            formatRemindDate(dateTime) {
                if (!dateTime) {
                    return "";
                }
                let w = new Date(dateTime).getDay(); // 曜日
                let dateDayOfWeek = moment(dateTime).format('YYYY/MM/DD') + "(" + DAY_OF_WEEK[w] + ")";
                let km = moment(dateTime).format('kk:mm');
                return dateDayOfWeek + ' ' + km;
            },
            // リマインドする
            remind(item) {
                this.disabled = true;
                axios.post('/documents/document-management/remind/' + item.id ,{    // 契約送付先のID
                    destination_user_name: item.destination_user_name,              // 契約送付先氏名
                    destination_company_name: item.destination_company_name,        // 契約送付先企業名
                    destination_email_address: item.destination_email_address,      // 契約送付先メールアドレス
                    is_authorizer: item.is_authorizer                               // 承認者フラグ
                    
                }).then(res => {
                    if (res.data.success) {
                        this.reminderEmail = res.data.reminderEmail;
                        this.isExistsReminderEnable = res.data.isExistsReminderEnable;
                        this.message.text = res.data.message;
                        this.message.success = true;
                        
                    } else {
                        this.disabled = false;
                        this.message.text = res.data.message;
                        this.message.success = false;
                    }
                }) .catch(err => {
                    this.disabled = false;
                    this.message.text = err.data.message;
                })
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '../../../sass/app.scss';
    /* table */
    td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
        padding: 5px 0;
    }
    ::v-deep .v-data-table__empty-wrapper {
        display: none;
    }
</style>
